<section>
  <div class="top-panel" *ngIf="!hideCheckBox">
    <div class="checkbox-panel" [ngClass]="{'checkbox-disabled': clinicalSignificanceDataExists || readOnly}">
      <span class="top-panel titles">{{title}}</span>
      <p-checkbox *ngIf="!approvedMode || noClinicalSignificancePublications"
        [ngClass]="{'diff_marker': noClinicalSignificancePublicationsShowChanged}"
        checkboxIcon="icon__Checkmark1"
        genTooltip
        genEllipsis
        [tooltipPosition]="'TOP'"
        [tooltipText]="'Disabled because evidence for clinical significance has been entered'"
        [tooltipShow]="clinicalSignificanceDataExists && !readOnly"
        name="noClinicalSignificancePublications"
        binary="true"
        label="No evidence for clinical significance (Level of Evidence F)"
        [disabled]="clinicalSignificanceDataExists || readOnly"
        [(ngModel)]="noClinicalSignificancePublications"
        (onChange)="noPublicationChecked($event)">
      </p-checkbox>
    </div>
  </div>
  <section class="item-container">
    <gen-curation-editor-items-container
      [readOnly]="readOnly"
      [curationData]="_curationData"
      [curationItem]="curationItem"
      [title]="'Diagnostic'"
      [itemTitle]="'Diagnostic'"
      [vertical]="true"
      [rootType]="rootType"
      [formName]="diagnosticFormName"
      [filterValue]="'diagnostic'"
      [filterParam]="'significanceType.code'"
      [hiddenFieldName]="'significanceType'"
      [hiddenFieldDisplay]="'Diagnostic'"
      [subItem]="true"
      [revisionTag]="revisionTag"
      [showAddButton]="!noClinicalSignificancePublications"
      [showDeleteButton]="!noClinicalSignificancePublications"
      [submitted]="submitted"
      [approvedMode]="approvedMode"
      [searchable]="true"
      [searchDataConfigParams]="searchDataConfigParams"
      [googleSearchURL]="googleSearchURL"
      [pubmedSearchURL]="pubmedSearchURL"
      (itemDeleted)="deleteItem($event)"
      (itemAdded)="itemAdded($event)"
      (validated)="validationEvent($event)"
    >
    </gen-curation-editor-items-container>
  </section>
  <section class="item-container">
    <gen-curation-editor-items-container
      [readOnly]="readOnly"
      [curationData]="_curationData"
      [curationItem]="curationItem"
      [title]="'Prognostic'"
      [itemTitle]="'Prognostic'"
      [vertical]="true"
      [rootType]="rootType"
      [formName]="prognosticFormName"
      [filterValue]="'prognostic'"
      [filterParam]="'significanceType.code'"
      [hiddenFieldName]="'significanceType'"
      [hiddenFieldDisplay]="'Prognostic'"
      [subItem]="true"
      [showAddButton]="!noClinicalSignificancePublications"
      [showDeleteButton]="!noClinicalSignificancePublications"
      [revisionTag]="revisionTag"
      [submitted]="submitted"
      [approvedMode]="approvedMode"
      [searchable]="true"
      [searchDataConfigParams]="searchDataConfigParams"
      [googleSearchURL]="googleSearchURL"
      [pubmedSearchURL]="pubmedSearchURL"
      (itemDeleted)="deleteItem($event)"
      (itemAdded)="itemAdded($event)"
      (validated)="validationEvent($event)">
    </gen-curation-editor-items-container>
  </section>
  <section class="item-container">
    <gen-curation-editor-items-container
      [readOnly]="readOnly"
      [curationData]="_curationData"
      [curationItem]="curationItem"
      [title]="'Therapeutic'"
      [itemTitle]="'Therapeutic'"
      [vertical]="true"
      [rootType]="rootType"
      [formName]="therapeuticFormName"
      [filterValue]="'therapeutic'"
      [filterParam]="'significanceType.code'"
      [hiddenFieldName]="'significanceType'"
      [hiddenFieldDisplay]="'therapeutic'"
      [subItem]="true"
      [showAddButton]="!noClinicalSignificancePublications"
      [showDeleteButton]="!noClinicalSignificancePublications"
      [revisionTag]="revisionTag"
      [submitted]="submitted"
      [approvedMode]="approvedMode"
      [searchable]="true"
      [searchDataConfigParams]="searchDataConfigParams"
      [googleSearchURL]="googleSearchURL"
      [pubmedSearchURL]="pubmedSearchURL"
      (itemDeleted)="deleteItem($event)"
      (itemAdded)="itemAdded($event)"
      (validated)="validationEvent($event)">
    </gen-curation-editor-items-container>
  </section>
</section>
